module.exports = __webpack_public_path__ + "static/media/ai.97171fd6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ai.svg
// module id = 2031
// module chunks = 0